import axios from "axios";
import store from '@/store';

export function createAuthGuard (idType = 'businessId') {
  return async (to, from, next) => {
    const businessId = to.params.id || to.query.shop_id;
    const businessType = to.params.type || store.getters.userType; // 這裡做判斷

    if (!businessId) {
      next();
      return;
    }

    console.log(`正在檢查授權：businessId = ${businessId}, businessType = ${businessType}`);

    try {
      if (businessType === 'gaa') {
        next();
        return;
      }

      const apiUrl = `${process.env.VUE_APP_APIHOST}/${businessType}/check-auth`
      
      const response = await axios.post(apiUrl,  {
        options: {
          accountId: idType === 'accountId' ? businessId: undefined, 
          businessId: idType === 'businessId' ? businessId: undefined,
        }
      });

      const isAuthorized = response.data.authorized
      if (isAuthorized) {
        console.log('授權檢查通過！');
        next();
      } else {
        console.warn('授權檢查失敗：找不到相符的 businessId');
        // alert('授權檢查失敗：找不到相符的 businessId')
        next({name: 'NotAuthorized'}); // 停留在原頁面
      }
    } catch (error) {
      console.error('API 權限檢查失敗:', error);
      next({name: 'NotAuthorized'}); // 停留在原頁面
    }
  };
};


export function createCampaignAuthGuard () {
  return async (to, from, next) => {
    const campaignId = to.params.groupId;
    const businessType = store.getters.userType; // 這裡做判斷

    if (!campaignId) {
      next();
      return;
    }

    console.log(`正在檢查授權：campaignId = ${campaignId}`);

    try {
      if (businessType === 'gaa') {
        next(); 
        return;
      } else if (businessType === 'eaa') {
        next({name: 'NotAuthorized'}); // 停留在原頁面
        return;
      }
      
      const apiUrl = `${process.env.VUE_APP_APIHOST}/${businessType}/check-campaign-admin`
      
      const response = await axios.post(apiUrl,  {
        campaignId
      });

      const isAuthorized = response.data.authorized
      if (isAuthorized) {
        console.log('授權檢查通過！');
        next();
      } else {
        console.warn('授權檢查失敗：找不到相符的 campaignId');
        next({name: 'NotAuthorized'}); // 停留在原頁面
      }
    } catch (error) {
      console.error('API 權限檢查失敗:', error);
      next({name: 'NotAuthorized'}); // 停留在原頁面
    }
  };
};

// 檢查EAA 是屬於SI 的
export function createSiEaaAuthGuard () {
  return async (to, from, next) => {
    const eaaAccountId = to.params.eaaId;
    const businessType = store.getters.userType; // 這裡做判斷

    if (!eaaAccountId) {
      next();
      return;
    }

    console.log(`正在檢查授權：eaaAccountId = ${eaaAccountId}`);

    try {
      if (businessType === 'gaa') {
        next(); 
        return;
      } else if (businessType === 'eaa') {
        next({name: 'NotAuthorized'}); // 停留在原頁面
        return;
      }

      const apiUrl = `${process.env.VUE_APP_APIHOST}/${businessType}/check-eaa-account`
      
      const response = await axios.post(apiUrl,  {
        eaaAccountId
      });

      const isAuthorized = response.data.authorized
      if (isAuthorized) {
        console.log('授權檢查通過！');
        next();
      } else {
        console.warn('授權檢查失敗：找不到相符的 campaignId');
        next({name: 'NotAuthorized'}); // 停留在原頁面
      }
    } catch (error) {
      console.error('API 權限檢查失敗:', error);
      next({name: 'NotAuthorized'}); // 停留在原頁面
    }
  };
};

// 檢查SI USER 是屬於 SI 的
export function createSiUserAuthGuard () {
  return async (to, from, next) => {
    const siId = to.params.siId;
    const siUserId = to.params.siUserId;
    const businessType = store.getters.userType; // 這裡做判斷
    const userId = store.getters.user.id; 
    if (!siUserId) {
      next();
      return;
    }

    console.log(`正在檢查授權：siUserId = ${siUserId}`);
    try {
      if (businessType === 'gaa') {
        next(); 
        return;
      } else if (businessType === 'eaa' || userId.toString() !== siId.toString()) {
        next({name: 'NotAuthorized'}); // 停留在原頁面
        return;
      } 

      const apiUrl = `${process.env.VUE_APP_APIHOST}/${businessType}/check-si-user`
      
      const response = await axios.post(apiUrl,  {
        siUserId
      });

      const isAuthorized = response.data.authorized
      if (isAuthorized) {
        console.log('授權檢查通過！');
        next();
      } else {
        console.warn('授權檢查失敗：找不到相符的 campaignId');
        next({name: 'NotAuthorized'}); // 停留在原頁面
      }
    } catch (error) {
      console.error('API 權限檢查失敗:', error);
      next({name: 'NotAuthorized'}); // 停留在原頁面
    }
  };
};
